import {
  isInIframe,
  listenToParentMessages,
  postMessageToParent,
} from "@hoppscotch/common/helpers/utils/iframe"
import {
  HoppBgColor,
  HoppBgColors,
  applySetting,
  unlockTheme,
  lockTheme,
} from "@hoppscotch/common/newstore/settings"

const isSupportedTheme = (value: string): value is HoppBgColor => {
  return HoppBgColors.includes(value as HoppBgColor)
}

// Normalize various parent postMessage payloads into a valid theme value
const extractThemeMode = (payload: unknown): HoppBgColor | null => {
  if (typeof payload === "string" && isSupportedTheme(payload)) {
    return payload
  }

  if (!payload || typeof payload !== "object") return null

  const data = payload as Record<string, unknown>
  const eventType = (data.type ?? data.event) as string | undefined

  if (eventType !== "themeMode") return null

  const candidate = data.mode ?? data.theme ?? data.payload ?? data.data
  return typeof candidate === "string" && isSupportedTheme(candidate)
    ? candidate
    : null
}

export const initParentBridge = () => {
  // Parent bridge only matters inside iframe embeds
  if (!isInIframe()) {
    return {
      stop: () => {},
      notifyReady: () => {},
    }
  }

  // Listen for themeMode events emitted by the hosting shell
  const stopListening = listenToParentMessages((event) => {
    const themeMode = extractThemeMode(event.data)
    if (!themeMode) return

    // 临时解锁主题以允许 postMessage 修改
    unlockTheme()

    // Align Hoppscotch theme with container preference
    applySetting("BG_COLOR", themeMode)

    // 立即设置 DOM class
    document.documentElement.setAttribute("class", themeMode)

    // 重新锁定主题（保持 iframe 主题控制）
    lockTheme(themeMode)

    console.log(
      `[ParentBridge] 主题已通过 postMessage 更新并重新锁定: ${themeMode}`
    )
  })

  // Notify parent that the self-host web app finished booting
  const notifyReady = () => postMessageToParent({ type: "selfhost-web:ready" })

  notifyReady()

  return {
    stop: stopListening,
    notifyReady,
  }
}
